import { render } from "./myMeals.vue?vue&type=template&id=f1f6f646&scoped=true"
import script from "./myMeals.vue?vue&type=script&lang=js"
export * from "./myMeals.vue?vue&type=script&lang=js"

import "./myMeals.vue?vue&type=style&index=0&id=f1f6f646&scoped=true&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f6f646"]])

export default __exports__